var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRental(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7826 4L21.7391 21.0435C20 20.1739 18.087 19.6522 16.1739 19.6522C9.3913 19.6522 4 25.0435 4 31.8261C4 38.6087 9.3913 44 16.1739 44C22.9565 44 28.3478 38.6087 28.3478 31.8261C28.3478 29.7391 27.8261 27.8261 26.9565 26.2609L32.6957 20.5217H35.3043V17.913L36.1739 17.0435H38.7826V14.4348L39.6522 13.5652H42.2609V10.9565L44 9.21739V4H38.7826Z",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6957 37.913C14.1365 37.913 15.3044 36.7451 15.3044 35.3043C15.3044 33.8636 14.1365 32.6956 12.6957 32.6956C11.255 32.6956 10.087 33.8636 10.087 35.3043C10.087 36.7451 11.255 37.913 12.6957 37.913Z",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRental);
export default __webpack_public_path__ + "static/media/Icon-rental.645d0959b87a8b83a051e19cfb6b4eef.svg";
export { ForwardRef as ReactComponent };